import { autorun, makeAutoObservable } from "mobx";
import { RootStore } from "./RootStore.ts";
import { Passphrase } from "./GlobalStore.ts";

type WelcomePage =
    | "CreateOrLogin"
    | "PassphraseShow"
    | "PassphraseCheck"
    | "SetPassword"
    | "EnterPassphrase"
    | "ChoosePublicKeys";
type PassphraseArray = string[] | undefined;

export class WelcomePageStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
        autorun(() => {
            if (this.passphrase_array) {
                this.passphrase = this.passphrase_array.join(" ");
            } else {
                this.passphrase = undefined;
            }
        });
    }

    page_history: WelcomePage[] = ["CreateOrLogin"];

    resetHistory() {
        this.page_history = ["CreateOrLogin"];
        this.current_page = "CreateOrLogin";
    }

    addPage(page: WelcomePage) {
        this.page_history.push(page);
        this.setPage(page);
    }

    removeCurrentPage() {
        this.page_history = this.page_history.filter((item) => item !== this.current_page);
        const previous_page = this.page_history.at(-1);
        this.setPage(previous_page ? previous_page : "CreateOrLogin");
    }

    previous_page: WelcomePage = "CreateOrLogin";

    setPreviousPage(page: WelcomePage) {
        this.previous_page = page;
    }

    current_page: WelcomePage = "CreateOrLogin";

    setPage(page: WelcomePage) {
        this.setPreviousPage(this.current_page);
        this.current_page = page;
        console.log(this.current_page);
    }

    passphrase_array: PassphraseArray = undefined;

    setPassphraseArray(passphrase_array: PassphraseArray) {
        this.passphrase_array = passphrase_array;
    }

    passphrase: Passphrase = undefined;

    getPassphrase() {
        if (!this.passphrase) throw new Error("Passphrase is undefined!");
        return this.passphrase;
    }

    password = "";

    setPassword(password: string) {
        this.password = password;
    }
}
